import { render } from "./SectionMAMs.vue?vue&type=template&id=8f9426de"
import script from "./SectionMAMs.vue?vue&type=script&lang=js"
export * from "./SectionMAMs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__